/* WWC mobile polish, 31 Oct 2026. Hide-on-scroll header, PDP sticky add to cart, back to top, search keyboard hints. */
(function () {
  'use strict';
  if (window.__wwcMobilePolish) return; window.__wwcMobilePolish = 1;
  var mq = window.matchMedia('(max-width: 1023px)');
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function visible(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; }

  /* 1. Search: show a "Search" key on the phone keyboard; no autocorrect on product codes */
  function searchHints(scope) {
    (scope || document).querySelectorAll('input[type=search], input[name=q]').forEach(function (i) {
      if (!i.hasAttribute('enterkeyhint')) i.setAttribute('enterkeyhint', 'search');
      if (!i.hasAttribute('autocorrect')) i.setAttribute('autocorrect', 'off');
      if (!i.hasAttribute('autocapitalize')) i.setAttribute('autocapitalize', 'off');
      if (!i.hasAttribute('spellcheck')) i.setAttribute('spellcheck', 'false');
    });
    (scope || document).querySelectorAll('input[type=email]:not([autocomplete])').forEach(function (i) { i.setAttribute('autocomplete', 'email'); });
    (scope || document).querySelectorAll('input[type=tel]:not([autocomplete])').forEach(function (i) { i.setAttribute('autocomplete', 'tel'); });
  }

  /* 2. Header: hide on scroll down, show on scroll up (mobile only) */
  function headerBusy() {
    var a = document.activeElement;
    if (a && /INPUT|TEXTAREA|SELECT/.test(a.tagName) && a.closest('.header-section')) return true;
    if (document.querySelector('.header-section details[open], .predictive-search-open, menu-drawer[open], .menu-drawer[open], drawer-component[open]')) return true;
    var b = document.body; if (b && (getComputedStyle(b).overflow === 'hidden' || root.classList.contains('overflow-hidden') || b.classList.contains('overflow-hidden'))) return true;
    return false;
  }
  function initHeader() {
    /* The theme adds .header-sticky after this script runs, so look the header up on each scroll */
    var lastY = window.scrollY, ticking = false, acc = 0;
    function update() {
      ticking = false;
      var hdr = document.querySelector('.header-section.header-sticky');
      var y = Math.max(0, window.scrollY), d = y - lastY; lastY = y;
      if (!hdr || !mq.matches || headerBusy() || y < hdr.offsetHeight * 2) { root.classList.remove('wwc-hdr-up'); acc = 0; return; }
      if ((d > 0) !== (acc > 0)) acc = 0;
      acc += d;
      if (acc > 24) root.classList.add('wwc-hdr-up');
      else if (acc < -12) root.classList.remove('wwc-hdr-up');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('.header-section')) root.classList.remove('wwc-hdr-up'); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.header-section, [data-wwc-show-header]')) root.classList.remove('wwc-hdr-up'); }, true);
  }

  /* 3. Back to top */
  function initBackToTop() {
    if (document.querySelector('.back-to-top, back-to-top, [data-back-to-top]')) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'wwc-btt'; btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 19V5"/><path d="m5 12 7-7 7 7"/></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var skip = document.querySelector('a.skip-to-content-link') ; if (skip) { try { document.body.focus({ preventScroll: true }); } catch (e) {} }
    });
    document.body.appendChild(btn);
    var on = false, t = false;
    function upd() {
      t = false;
      var long = document.documentElement.scrollHeight > window.innerHeight * 3;
      var want = long && window.scrollY > window.innerHeight * 1.5;
      if (want !== on) { on = want; btn.classList.toggle('is-on', on); }
      if (on) { var tab = document.querySelector('.wwc-nltab'); btn.classList.toggle('wwc-btt--tab', !!(tab && visible(tab) && getComputedStyle(tab).visibility !== 'hidden')); }
    }
    window.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* 4. PDP sticky add to cart (mobile). Proxies the size/quantity matrix's own Add to cart button. */
  function initStickyATC() {
    if (!document.body.classList.contains('template-product') && !document.querySelector('product-info, [id^=ProductInfo-]')) return;
    var real = document.querySelector('.wwc-panel--docs .wwc-btn--orange.wwc-btn--block, [data-wwc-inline] .wwc-btn--orange');
    var panel = document.querySelector('[data-wwc-inline] .wwc-panel, .wwc-panel--docs');
    if (!real || !panel) return;
    if (document.querySelector('[data-wwc-sticky-atc], sticky-atc-bar, .sticky-atc-bar')) {
      var other = document.querySelector('[data-wwc-sticky-atc], sticky-atc-bar, .sticky-atc-bar');
      if (visible(other) || other.hasAttribute('data-wwc-sticky-atc')) return;
    }
    var h1 = document.querySelector('h1');
    var priceEl = document.querySelector('.wwc-pdp-price');
    var bar = document.createElement('div');
    bar.className = 'wwc-satc'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML = '<div class="wwc-satc__info"><div class="wwc-satc__title"></div><div class="wwc-satc__price"></div></div><button type="button" class="wwc-satc__btn"></button>';
    var tEl = bar.querySelector('.wwc-satc__title'), pEl = bar.querySelector('.wwc-satc__price'), bEl = bar.querySelector('.wwc-satc__btn');
    tEl.textContent = h1 ? h1.textContent.trim() : '';
    function priceText() {
      if (!priceEl) return '';
      var lines = priceEl.innerText.split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      return lines[0] || '';
    }
    function sync() {
      var ready = !real.disabled;
      bEl.textContent = ready ? 'Add to cart' : 'Choose sizes';
      var p = priceText();
      var m = p.match(/^(\S+)\s+(.*)$/);
      pEl.innerHTML = '';
      if (m) { pEl.textContent = m[1] + ' '; var s = document.createElement('small'); s.textContent = m[2]; pEl.appendChild(s); } else pEl.textContent = p;
    }
    sync();
    new MutationObserver(function () { sync(); apply(); }).observe(real, { attributes: true, attributeFilter: ['disabled'] });
    if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
    bEl.addEventListener('click', function () {
      if (!real.disabled) { real.click(); return; }
      var head = panel.querySelector('.wwc-panel__title') || panel;
      var hs = document.querySelector('.header-section.header-sticky');
      var y = head.getBoundingClientRect().top + window.scrollY - (hs ? hs.offsetHeight : 0) - 12;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      var first = panel.querySelector('.wwc-step[data-inc]');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 450);
    });
    document.body.appendChild(bar);

    var panelInView = true, realInView = false, pastTop = false, typing = false, on = false;
    function apply() {
      var want = mq.matches && pastTop && !realInView && !(real.disabled && panelInView) && !typing && !document.querySelector('cart-drawer[open], drawer-component[open], .drawer[open]');
      if (want !== on) { on = want; bar.classList.toggle('is-on', on); document.body.classList.toggle('wwc-satc-on', on); bar.toggleAttribute('inert', !on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    }
    bar.setAttribute('aria-hidden', 'true'); bar.toggleAttribute('inert', true);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { panelInView = es[0].isIntersecting; apply(); }, { rootMargin: '-25% 0px -25% 0px' }).observe(panel);
      new IntersectionObserver(function (es) { realInView = es[0].isIntersecting; apply(); }).observe(real);
    }
    var t = false;
    window.addEventListener('scroll', function () {
      if (t) return; t = true;
      requestAnimationFrame(function () { t = false; pastTop = window.scrollY > (priceEl ? priceEl.getBoundingClientRect().bottom + window.scrollY - 80 : 500); apply(); });
    }, { passive: true });
    document.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches('input:not([type=checkbox]):not([type=radio]), textarea, select')) { typing = true; apply(); } });
    document.addEventListener('focusout', function () { typing = false; setTimeout(apply, 50); });
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  ready(function () {
    try { searchHints(); } catch (e) {}
    try { initHeader(); } catch (e) {}
    try { initStickyATC(); } catch (e) {}
    try { initBackToTop(); } catch (e) {}
    document.addEventListener('shopify:section:load', function (e) { try { searchHints(e.target); } catch (x) {} });
  });
})();
